const DIRECTION_ROUNDTRIP = 'Roundtrip';
const DIRECTION_ONEWAY = 'Oneway';

export default function TripItemRailRecommendationService() {
    Object.assign(this, {
        getAllStations,
        getKeyStations,
        getAllStationsCodes,
        isDirectionRoundtrip,
        isDirectionOneway,
    });

    function getAllStations(railRecommendation) {
        return getAllRails(railRecommendation, 'DepartureStation', 'ArrivalStation');
    }

    function getKeyStations(railRecommendation) {
        return getKeyRails(railRecommendation, 'DepartureStation', 'ArrivalStation');
    }

    function getAllStationsCodes(railRecommendation) {
        return getAllRails(railRecommendation, 'DepartureStationCode', 'ArrivalStationCode');
    }

    function getAllRails(railRecommendation, fieldDeparture, fieldArrival) {
        if (!(railRecommendation && railRecommendation.RailGroups)) {
            return [];
        }

        const allStops = railRecommendation.RailGroups
            .reduce((acc, railGroup) => [...acc, ...railGroup.Rails], []);
        const lastStop = allStops[allStops.length - 1];
        return [
            ...allStops.map((stop) => stop[fieldDeparture]),
            ...lastStop && lastStop[fieldArrival] || [],
        ];
    }

    function getKeyRails(flightRecommendation, fieldDeparture, fieldArrival) {
        if (!(flightRecommendation && flightRecommendation.RailGroups)) {
            return [];
        }

        const getAppropriateRailStops = function(recommendation, first, last, index, array) {
            if (isRoundTrip(recommendation)) {
                return (index === array.length - 1) ? [last] : [first, last];
            }

            return [first, last];
        };

        return flightRecommendation.RailGroups
            .filter((group) => !!(group && group.Rails && group.Rails.length))
            .reduce((acc, railGroup) => [
                ...acc,
                {
                    first: railGroup.Rails[0][fieldDeparture],
                    last: railGroup.Rails[railGroup.Rails.length - 1][fieldArrival],
                },
            ], [])
            .reduce((acc, {first, last}, index, array) => [
                ...acc,
                ...getAppropriateRailStops(flightRecommendation, first, last, index, array),
            ], []);
    }


    function getFirstRail(recommendation) {
        return recommendation
            && recommendation.RailGroups
            && recommendation.RailGroups.length
            && recommendation.RailGroups[0].Rails
            && recommendation.RailGroups[0].Rails.length
            && recommendation.RailGroups[0].Rails[0]
            || null;
    }

    function getLastRail(recommendation) {
        if (!(recommendation
            && recommendation.RailGroups
            && recommendation.RailGroups.length)) {
            return null;
        }
        const lastGroupIndex = recommendation.RailGroups.length - 1;
        const lastGroup = recommendation.RailGroups[lastGroupIndex];
        if (!lastGroup.Rails || !lastGroup.Rails.length) {
            return null;
        }

        return lastGroup.Rails[lastGroup.Rails.length - 1];
    }
    function isRoundTrip(recommendation) {
        if (!recommendation || !recommendation.RailGroups || recommendation.RailGroups.length !== 2) {
            return false;
        }
        const firstRail = getFirstRail(recommendation);
        const lastRail = getLastRail(recommendation);

        return firstRail
            && lastRail
            && firstRail.DepartureCityCode === lastRail.ArrivalCityCode;
    }


    function isDirectionRoundtrip(railRecommendation) {
        return railRecommendation.ReturnOrSingle === DIRECTION_ROUNDTRIP;
    }

    function isDirectionOneway(railRecommendation) {
        return railRecommendation.ReturnOrSingle === DIRECTION_ONEWAY;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-rail-recommendation/trip-item-rail-recommendation-service.js